import { render, staticRenderFns } from "./addTaskDialog.vue?vue&type=template&id=286729d8&scoped=true"
import script from "./addTaskDialog.vue?vue&type=script&lang=js"
export * from "./addTaskDialog.vue?vue&type=script&lang=js"
import style0 from "./addTaskDialog.vue?vue&type=style&index=0&id=286729d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286729d8",
  null
  
)

export default component.exports